const MONEY_SCALE = 10;

export const toMoneyUnits = (value: number): number =>
  Number.isFinite(value) ? Math.round(value * MONEY_SCALE) : 0;

export const fromMoneyUnits = (units: number): number => units / MONEY_SCALE;

export const normalizeMoney = (value: number): number => fromMoneyUnits(toMoneyUnits(value));

export const moneyDifference = (left: number, right: number): number =>
  fromMoneyUnits(toMoneyUnits(left) - toMoneyUnits(right));
